<template>
    

        <!-- Transacciones -->
        <div class="section mt-4">
            <div class="section-heading">
              <h2 class="title">Transacciones</h2>
              <!-- <router-link :to="{ name: 'transactions' }" class="link">
                Ver Todas
              </router-link> -->
            </div>

            <div class="card">
              <ul class="listview image-listview flush">
                
                <li class="active placeholder-glow" v-if="loading == true">
                  <a class="item placeholder col-12">
                    <div class="icon-box bg-secondary">
                      <p class="placeholder image-block imaged w48"></p>
                    </div>
                    <div class="in">
                      <div>
                        <div class="mb-05">
                          <strong class="placeholder col-12"></strong>
                        </div>
                        <div class="text-small mb-05 placeholder col-12"> <b class="placeholder col-12"></b></div>
                        <div class="text-xsmall placeholder col-12"></div>
                      </div>
                      <span class="badge badge-primary badge-empty placeholder col-12"></span>
                    </div>
                  </a>
                </li>
                <li class="active placeholder-glow" v-if="loading == false && records.length == 0">
                  <a class="item col-12 placeholder">
                    <div class="icon-box bg-secondary">
                      <p class="placeholder image-block imaged w48"></p>
                    </div>
                    <div class="in">
                      <div>
                        <div class="mb-05">
                          <strong class="col-12">Buscando transacciones</strong>
                        </div>
                        <div class="text-small mb-05 col-12">No encontramos Txs, intenta en un rato. <b class="col-12"></b></div>
                        <div class="text-xsmall col-12">intenta en un rato.</div>
                      </div>
                      <span class="badge badge-primary badge-empty placeholder col-12"></span>
                    </div>
                  </a>
                </li>
                <li v-for="(tx, i_tx) in records" v-bind:key="'i_tx-' + i_tx" v-else>
                  <a href="#" class="item">
                    <div :class="'icon-box ' + colorTxt(tx)">
                      <ion-icon :name="iconTxt(tx)" role="img" class="md hydrated"></ion-icon>
                    </div>
                    <div class="in">
                      <div>
                        <div class="mb-05">
                          <strong>{{ labelTxt(tx) }}</strong>
                        </div>
                        <div class="text-small mb-05">{{ infoTxt(tx) }}</div>
                        <div class="text-xsmall">{{tx.created}}</div>
                      </div>
                      <span class="price text-info">
                        <a v-if="tx.status == 3 && tx.type == 'locked'" :href="'/withdraw/blocking/' + tx.id" class="btn btn-primary shadowed me-1 mb-1 btn-sm ">Reclamar</a>
                        {{ tx.amount }} {{ tx.asset.currency.symbol }}
                      </span>
                    </div>
                  </a>
                </li>
            </ul>
          </div>
        </div>
        <!-- * Transacciones -->

</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'HomeView',
  data() {
    return {
    //   networks: [],
    //   currencies: [],
      records: [],
      loading: true,
      form: {
        network: 0,
        asset: 0,
      }
    };
  },
  matches: {
    'form.network'() {
      this.form.asset = 0;
    }
  },
  computed: {
  },
  async mounted() {
    this.$root.loadBackButtom();
    this.$root.loadInputs();
    await this.loadTxs()
  },
  methods: {
    ...mapActions(['transactionsList']),
    colorTxt(tx) {
        if (tx.type == 'recharge') {
          if (tx.status == 1) return `bg-success`;
        }
        else if (tx.type == 'locked') {
          if (tx.status == 1) return `bg-info`;
          else if (tx.status == 3) return `bg-success`;
        }
        else if (tx.type == 'withdraw') {
          if (tx.status == 1) return `bg-success`;
        }
        return `bg-secondary`;
    },
    iconTxt(tx) {
        if (tx.type == 'recharge') {
          return `add-outline`;
        }
        else if (tx.type == 'locked') {
          if (tx.status == 3 && tx.type == 'locked') return 'lock-open-outline'
          return `lock-closed-outline`;
        }
        else if (tx.type == 'withdraw') {
            return `arrow-down-outline`;
        }
        return "bug-outline";
    },
    infoTxt(tx) {
        if (tx.type == 'recharge') {
          let res = `Recarga desde ${tx.network.name}`
            if (tx.status == 0) res += " Fallida (Solo creada)";
            if (tx.status == 1) res += " Exitosa";
            return res;
        }
        else if (tx.type == 'locked') {
            return `Agregarte liquidez en ${tx.asset.currency.symbol}`;
        }
        else if (tx.type == 'withdraw') {
            return `Retiro de  ${tx.asset.currency.symbol} para la red ${tx.asset.network.name}`;
        }
        else if (tx.type == 'transfer') {
            return `Transferencia`;
        }
        return "Desconocido";
    },
    labelTxt(tx) {
        if (tx.type == 'recharge') {
            return `Recarga desde ${tx.network.name} `;
        }
        else if (tx.type == 'locked') {
            console.log(tx.type_status)
            return `Bloqueo de ${tx.asset.currency.symbol}`;
        }
        else if (tx.type == 'withdraw') {
            console.log('withdraw', tx)
            return `Envio a la red ${tx.asset.network.name}`;
        }
        else if (tx.type == 'transfer') {
            console.log('withdraw', tx)
            return `Transferencia`;
        }
        return "Desconocido";
    },
    async loadTxs() {
      console.log('loadTxs')
      this.loading = true;
      const records = await this.transactionsList()
      console.log('records', records)
      this.records = records
      this.loading = false;
    }
  },
}
</script>
